// Defaults de renderização mapeados pela CHAVE do schema.
// Permite que o schema use ui:{} mínimo ou parcial; o front preenche o resto.
//
// Organização:
//   Seção 1 — Tráfego e pacotes (trafficIn/Out aparecem em mikrotik, bgp, datacom, fortigate)
//   Seção 2 — Conectividade ICMP  (mikrotik, datacom, icmp, fortigate)
//   Seção 3 — Informações do sistema (mikrotik, bgp, datacom, fortigate)
//   Seção 4 — Saúde do equipamento  (mikrotik, bgp, datacom)
//   Seção 5 — Óptica SFP            (datacom, onu)
//   Seção 6 — Fortigate WAN/VPN     (device-específico — só mantido pois Fortigate
//                                    é o único device usando GenericDashboard hoje)
export const METRIC_KEY_DEFAULTS = {

  // ── Seção 1: Tráfego e pacotes ───────────────────────────────────────────
  // mikrotik · bgp · datacom · fortigate
  trafficIn: {
    type: "trafficChart",
    color: "green",
    icon: "DownloadOutlined",
    title: "Tráfego de Entrada",
    section: "graph",
    lastOnly: false,
  },
  trafficOut: {
    type: "trafficChart",
    color: "orange",
    icon: "PublishOutlined",
    title: "Tráfego de Saída",
    section: "graph",
    lastOnly: false,
  },
  // mikrotik · datacom
  erroPacketIn: {
    type: "lineChart",
    color: "red",
    icon: "TrendingDownOutlined",
    title: "Erros de Entrada",
    section: "graph",
    lastOnly: false,
  },
  erroPacketOut: {
    type: "lineChart",
    color: "orange",
    icon: "TrendingDownOutlined",
    title: "Erros de Saída",
    section: "graph",
    lastOnly: false,
  },
  // mikrotik · datacom
  ifSpeed: {
    type: "textCard",
    title: "Velocidade de Negociação",
    section: "card",
    lastOnly: true,
    typeIcon: 1, // SpeedOutlined
    colorCard: "speeData",
  },

  // ── Seção 2: Conectividade ICMP ──────────────────────────────────────────
  // mikrotik · datacom · icmp · onu
  statusPing: {
    type: "statusChip",
    title: "Status PING",
    section: "card",
    lastOnly: true,
  },
  // mikrotik · bgp · datacom · icmp
  packetLoss: {
    type: "progressCard",
    icon: "TrendingDownOutlined",
    unit: "%",
    title: "Perda de Pacotes",
    section: "graph",
    lastOnly: false,
    progressRange: { min: 0, max: 100 },
    thresholdPreset: "packetLoss",
  },
  // mikrotik · datacom · icmp
  latency: {
    type: "lineChart",
    color: "blue",
    icon: "NetworkPing",
    unit: "ms",
    title: "Latência",
    section: "graph",
    lastOnly: false,
    range: { min: 0, max: 200 },
    formatPreset: "ping",
    showChipStatus: false,
    thresholdPreset: "latency",
  },
  // mikrotik · bgp · datacom · fortigate
  statusInterface: {
    type: "statusChip",
    title: "Status Interface",
    section: "card",
    lastOnly: true,
  },

  // ── Seção 3: Informações do sistema ──────────────────────────────────────
  // mikrotik · bgp · fortigate
  systemName: {
    type: "textCard",
    title: "Nome do Sistema",
    section: "card",
    lastOnly: true,
    typeIcon: 4, // QueryStatsOutlined
    colorCard: "speeData",
  },
  // mikrotik · bgp · datacom · fortigate
  systemModel: {
    type: "textCard",
    title: "Modelo",
    section: "card",
    lastOnly: true,
    typeIcon: 12, // RouterOutlined
    colorCard: "inputData",
  },
  // mikrotik · datacom · onu
  firmwareVersion: {
    type: "textCard",
    title: "Versão do Firmware",
    section: "card",
    lastOnly: true,
    typeIcon: 11, // MemoryOutlined
    colorCard: "speeData",
  },
  // mikrotik · bgp · onu
  sysUpTime: {
    type: "textCard",
    title: "Uptime",
    section: "card",
    lastOnly: true,
    typeIcon: 15, // AccessTimeOutlined
    colorCard: "speeData",
    formatPreset: "uptime",
  },

  // ── Seção 4: Saúde do equipamento ────────────────────────────────────────
  // mikrotik · bgp · datacom
  cpuUsage: {
    type: "lineChart",
    color: "blue",
    icon: "SpeedOutlined",
    unit: "%",
    title: "CPU",
    section: "graph",
    lastOnly: false,
    range: { min: 0, max: 100 },
    formatPreset: "percent",
  },
  // mikrotik · bgp
  ramUsage: {
    type: "lineChart",
    color: "orange",
    icon: "StorageOutlined",
    unit: "%",
    title: "Memória RAM",
    section: "graph",
    lastOnly: false,
    range: { min: 0, max: 100 },
    formatPreset: "percent",
  },
  // mikrotik · bgp · datacom
  equipmentTemperature: {
    type: "lineChart",
    color: "orange",
    icon: "DeviceThermostatOutlined",
    unit: "°C",
    title: "Temperatura",
    section: "graph",
    lastOnly: false,
  },
  // mikrotik · bgp (via dashHealth)
  supplyVoltage: {
    type: "textCard",
    title: "Tensão da Fonte",
    section: "card",
    lastOnly: true,
    typeIcon: 6, // HandymanOutlined
    colorCard: "inputData",
  },

  // ── Seção 5: Óptica SFP ──────────────────────────────────────────────────
  // datacom · onu
  receivedPower: {
    type: "lineChart",
    color: "blue",
    icon: "DownloadOutlined",
    unit: "dBm",
    title: "Potência Recebida",
    section: "graph",
    lastOnly: false,
    thresholdPreset: "rxPower",
  },
  transmittedPower: {
    type: "lineChart",
    color: "orange",
    icon: "PublishOutlined",
    unit: "dBm",
    title: "Potência Transmitida",
    section: "graph",
    lastOnly: false,
  },

  // ── Seção 6: Fortigate WAN/VPN ───────────────────────────────────────────
  // Device-específico — só Fortigate usa GenericDashboard hoje.
  // Manter aqui evita repetir esses campos no schema quando ui:{}.
  // Itens SD-WAN: multi-instância — cada WAN[n] vira uma linha no gráfico
  wanLatency: {
    type: "multiLineChart",
    color: "blue",
    icon: "NetworkPing",
    unit: "ms",
    title: "Latência WAN",
    section: "graph",
    group: "wan",
    lastOnly: false,
    // forceObject garante retorno keyed mesmo com uma única WAN
    fetchParams: { forceObject: true },
    // Zabbix retorna em segundos; converte para ms
    valueMultiplier: 1000,
    hideProgress: true,
    // Extrai o nome descritivo do item Zabbix (após ": ") para exibir nas linhas
    labelExtractor: "^[^:]*:\\s*(.*)$",
  },
  wanJitter: {
    type: "multiLineChart",
    color: "orange",
    icon: "NetworkPing",
    unit: "ms",
    title: "Jitter WAN",
    section: "graph",
    group: "wan",
    lastOnly: false,
    fetchParams: { forceObject: true },
    // Zabbix retorna em segundos; converte para ms
    valueMultiplier: 1000,
    hideProgress: true,
    labelExtractor: "^[^:]*:\\s*(.*)$",
  },
  wanPacketLoss: {
    type: "multiLineChart",
    color: "red",
    icon: "TrendingDownOutlined",
    unit: "%",
    title: "Perda de Pacotes WAN",
    section: "graph",
    group: "wan",
    lastOnly: false,
    fetchParams: { forceObject: true },
    labelExtractor: "^[^:]*:\\s*(.*)$",
  },
  vpnStatus: {
    type: "textCard",
    title: "Status VPN",
    section: "card",
    lastOnly: true,
    typeIcon: 14, // CheckOutlined
    colorCard: "statusUp",
  },
  vpnTrafficIn: {
    type: "multiLineChart",
    color: "blue",
    icon: "DownloadOutlined",
    title: "Tráfego VPN (Entrada)",
    section: "graph",
    lastOnly: false,
  },
  vpnTrafficOut: {
    type: "multiLineChart",
    color: "orange",
    icon: "PublishOutlined",
    title: "Tráfego VPN (Saída)",
    section: "graph",
    lastOnly: false,
  },
  activeSessions: {
    type: "textCard",
    title: "Sessões Ativas",
    section: "card",
    lastOnly: true,
    typeIcon: 5, // GroupAddOutlined
    colorCard: "outputData",
  },

  // ── Seção 7: Fortigate HA (Alta Disponibilidade) ─────────────────────────
  // Itens únicos por host (modo/grupo/serial) → cards.
  // Itens por membro do cluster (CPU/Memória/Rede/Sessões/Sincronismo) →
  // multi-instância (igual à WAN): cada membro vira uma linha no gráfico.
  // labelExtractor extrai o nome do membro de "... do membro <NOME> (<serial>)".
  // group:"ha" → usado pela aba HA do GenericDashboard.
  haSystemMode: {
    type: "textCard",
    title: "Modo de Operação (HA)",
    section: "card",
    group: "ha",
    lastOnly: true,
    typeIcon: 12, // RouterOutlined
    colorCard: "inputData",
    formatPreset: "haMode",
  },
  haGroupName: {
    type: "textCard",
    title: "Grupo HA",
    section: "card",
    group: "ha",
    lastOnly: true,
    typeIcon: 4, // QueryStatsOutlined
    colorCard: "speeData",
  },
  haMasterSerial: {
    type: "textCard",
    title: "Serial do Primário (Master)",
    section: "card",
    group: "ha",
    lastOnly: true,
    typeIcon: 11, // MemoryOutlined
    colorCard: "inputData",
  },
  haCpuUsage: {
    type: "multiLineChart",
    title: "CPU por Membro (HA)",
    unit: "%",
    section: "graph",
    group: "ha",
    lastOnly: false,
    fetchParams: { forceObject: true },
    labelExtractor: "do membro\\s+(.+?)\\s*\\(",
  },
  haMemUsage: {
    type: "multiLineChart",
    title: "Memória por Membro (HA)",
    unit: "%",
    section: "graph",
    group: "ha",
    lastOnly: false,
    fetchParams: { forceObject: true },
    labelExtractor: "do membro\\s+(.+?)\\s*\\(",
  },
  // Uso de rede em bits/s → formata bps/Kbps/Mbps/Gbps; sem barra de progresso.
  haNetUsage: {
    type: "multiLineChart",
    title: "Uso de Rede por Membro (HA)",
    section: "graph",
    group: "ha",
    lastOnly: false,
    hideProgress: true,
    formatPreset: "bps",
    fetchParams: { forceObject: true },
    labelExtractor: "do membro\\s+(.+?)\\s*\\(",
  },
  // Sessões = contagem inteira; sem barra de progresso e sem unidade/%.
  haSesCount: {
    type: "multiLineChart",
    title: "Sessões por Membro (HA)",
    section: "graph",
    group: "ha",
    lastOnly: false,
    hideProgress: true,
    formatPreset: "count",
    fetchParams: { forceObject: true },
    labelExtractor: "do membro\\s+(.+?)\\s*\\(",
  },
  // Sincronismo = estado binário; exibe texto "Sincronizado"/"Fora de sincronia".
  // Esconde min/max/avg (não fazem sentido) e fixa o eixo Y em 2 rótulos (0 e 1).
  haSyncStatus: {
    type: "multiLineChart",
    title: "Sincronismo por Membro (HA)",
    section: "graph",
    group: "ha",
    lastOnly: false,
    hideProgress: true,
    hideStats: true,
    formatPreset: "haSync",
    chartDomain: [0, 1],
    chartTicks: [0, 1],
    fetchParams: { forceObject: true },
    labelExtractor: "do membro\\s+(.+?)\\s*\\(",
  },
};
